/**
 * ContactFields — 4 campi strutturati per un referente di sede.
 * Riusabile: Sede Legale + ogni Sede Operativa.
 *
 * value shape:  { ref_titolo, ref_nome, ref_cognome, ref_ruolo }
 * onChange:     (partial) => void  (merge-shallow)
 */
import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

export const TITOLI_REFERENTE = [
  "Sig.", "Sig.ra", "Dott.", "Dott.ssa", "Ing.", "Avv.",
  "Arch.", "Prof.", "Prof.ssa", "Rag.", "Geom.", "Cav.", "Comm.",
];

export function ContactFields({ value = {}, onChange, testidPrefix = "ref" }) {
  const patch = (key, v) => onChange({ ...value, [key]: v });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-12 gap-3">
      <div className="sm:col-span-2">
        <Label className="text-xs font-medium text-slate-600">Titolo</Label>
        <Select
          value={value.ref_titolo || ""}
          onValueChange={(v) => patch("ref_titolo", v === "__NONE__" ? "" : v)}
        >
          <SelectTrigger
            className="mt-1 h-9 rounded-md border-slate-200 bg-white"
            data-testid={`${testidPrefix}-titolo`}
          >
            <SelectValue placeholder="—" />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            <SelectItem value="__NONE__">— nessuno —</SelectItem>
            {TITOLI_REFERENTE.map((t) => (
              <SelectItem key={t} value={t}>{t}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="sm:col-span-3">
        <Label className="text-xs font-medium text-slate-600">Nome</Label>
        <Input
          value={value.ref_nome || ""}
          onChange={(e) => patch("ref_nome", e.target.value)}
          className="mt-1 h-9 rounded-md border-slate-200 bg-white"
          placeholder="Mario"
          data-testid={`${testidPrefix}-nome`}
        />
      </div>
      <div className="sm:col-span-3">
        <Label className="text-xs font-medium text-slate-600">Cognome</Label>
        <Input
          value={value.ref_cognome || ""}
          onChange={(e) => patch("ref_cognome", e.target.value)}
          className="mt-1 h-9 rounded-md border-slate-200 bg-white"
          placeholder="Rossi"
          data-testid={`${testidPrefix}-cognome`}
        />
      </div>
      <div className="sm:col-span-4">
        <Label className="text-xs font-medium text-slate-600">Ruolo</Label>
        <Input
          value={value.ref_ruolo || ""}
          onChange={(e) => patch("ref_ruolo", e.target.value)}
          className="mt-1 h-9 rounded-md border-slate-200 bg-white"
          placeholder="Responsabile HSE"
          data-testid={`${testidPrefix}-ruolo`}
        />
      </div>
    </div>
  );
}
